import { CMS } from '@odiupsk/up-api-client'
import { observable } from 'mobx'
import { cmsApi } from '../../common/api'

export class StoreEndUserDashboard {
  @observable.ref banners: CMS.Banner[] = []

  @observable.ref articles: CMS.Article[] = []

  @observable.ref articlesCategories: CMS.ArticleCategory[] = []

  @observable.ref hints: CMS.Hint[] = []

  fetchBanners = async () => {
    const res = await cmsApi.getBanners({
      params: { app: 'web', show_on_dashboard: 1, target: 'end-user' },
    })
    this.banners = res.data.data || []
  }

  fetchArticles = async () => {
    const cats = await cmsApi.getArticleCategories()
    this.articlesCategories = cats.data.data || []

    const res = await cmsApi.getArticles({
      params: { orderBy: 'published_at', orderDirection: 'desc', per_page: 3, target: 'end-user' },
    })
    this.articles = res.data.data || []
  }

  fetchHints = async () => {
    const res = await cmsApi.getHints({
      params: {
        orderBy: 'published_at',
        orderDirection: 'desc',
        /* per_page: 3, */ target: 'end-user',
      },
    })
    this.hints = res.data.data || []
  }
}
